import { gql, MutationHookOptions, useMutation } from '@apollo/client';

const MUTATION = gql`
  mutation deleteQuizResponse($id: ID!) {
    deleteQuizResponse(id: $id)
  }
`;

export type Variables = {
  readonly id: string;
};

export type Response = {
  readonly deleteQuizResponse: boolean;
};

export const useDeleteQuizResponseMutation = (
  options: MutationHookOptions<Response, Variables> = {},
) => useMutation<Response, Variables>(MUTATION, options);